/** @format */

import { useState, useCallback } from "react";
import type { Brand } from "@question-bank/shared";
import { deleteQuestion as apiDeleteQuestion } from "../api/questions";

interface UseDeleteQuestionReturn {
	isDeleting: boolean;
	error: string | null;
	deleteQuestion: (questionId: string) => Promise<boolean>;
	reset: () => void;
}

export const useDeleteQuestion = (brand: Brand): UseDeleteQuestionReturn => {
	const [isDeleting, setIsDeleting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const deleteQuestion = useCallback(
		async (questionId: string): Promise<boolean> => {
			setIsDeleting(true);
			setError(null);
			try {
				await apiDeleteQuestion(brand, questionId);
				return true;
			} finally {
				setIsDeleting(false);
			}
		},
		[brand],
	);

	const reset = useCallback(() => setError(null), []);

	return { isDeleting, error, deleteQuestion, reset };
};
